/** @format */
import styled, { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { MarketSelectorLinkProps } from './types';

export const MarketSelectorLinkWrapper = styled.div`
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    column-gap: var(--layout-spacing-12);
    border-radius: 0.4rem;
    padding: var(--layout-spacing-8);
    align-items: center;
    cursor: pointer;

    &:hover {
        background-color: var(--colors-surface-secondary);
    }

    ${({ selected }: Omit<MarketSelectorLinkProps, 'market'>) => {
        if (!selected) return;

        return css`
            border: 1px solid var(--colors-border-secondary);
            ${theme.typography.body_normal_highlight}
            cursor: default;

            &:hover {
                background-color: var(--colors-surface-primary);
            }
        `;
    }}
`;

export const CheckmarkIconWrapper = styled.div`
    display: flex;

    .icon {
        font-size: 1.6rem;
    }
`;
